import React from 'react';
import { SectionWrapper } from './ui/SectionWrapper';
import { Button } from './ui/Button';
import { Shield, Lock, Zap } from 'lucide-react';
import { CountdownTimer } from './ui/CountdownTimer';
export function FinalCTA() {
  return <SectionWrapper className="text-center pb-12 md:pb-24 px-4 md:px-0" data-id="element-44">
      <div className="max-w-2xl mx-auto" data-id="element-45">
        <h2 className="text-[11px] md:text-sm font-black tracking-widest text-slate-400 uppercase mb-4 md:mb-8" data-id="element-46">
          🔚 ÚLTIMO MENSAJE
        </h2>

        <div className="text-[26px] md:text-4xl font-extrabold mb-8 md:mb-10 leading-tight text-white" data-id="element-47">
          Si vos no guiás…
          <br data-id="element-48" />
          <span className="text-sky-400" data-id="element-49">👉 alguien más lo va a hacer</span>
        </div>

        <div className="flex flex-col md:flex-row justify-center gap-2 md:gap-4 mb-10 md:mb-16 text-sm md:text-xl font-bold text-slate-300" data-id="element-50">
          <span className="bg-[#0d3354] shadow-sm px-4 py-3 md:px-6 md:py-3 rounded-xl border border-sky-900/40 w-full md:w-auto" data-id="element-51">
            Una red social
          </span>
          <span className="bg-[#0d3354] shadow-sm px-4 py-3 md:px-6 md:py-3 rounded-xl border border-sky-900/40 w-full md:w-auto" data-id="element-52">
            Un desconocido
          </span>
          <span className="bg-[#0d3354] shadow-sm px-4 py-3 md:px-6 md:py-3 rounded-xl border border-sky-900/40 w-full md:w-auto" data-id="element-53">
            Un algoritmo
          </span>
        </div>

        <div className="bg-[#0d3354] shadow-xl rounded-2xl md:rounded-3xl p-6 md:p-12 w-full border border-sky-900/40" data-id="element-54">
          <h3 className="text-lg md:text-2xl font-black text-white mb-2" data-id="element-55">
            ⏰ ACTUÁ HOY
          </h3>
          <p className="text-[15px] md:text-xl text-sky-400 font-bold mb-4 md:mb-6" data-id="element-56">
            📘 SISTEMA DIGITAL COMPLETO
          </p>
          <div className="text-4xl md:text-5xl font-black text-white mb-4 md:mb-6 tracking-tight" data-id="element-57">
            $19.990 ARS
          </div>

          <div className="mb-6 md:mb-8" data-id="element-58">
            <p className="text-red-500 font-bold flex items-center justify-center gap-1.5 text-[13px] md:text-base" data-id="element-59">
              ⚠️ Esta oferta termina en:
            </p>
            <CountdownTimer hideLabel data-id="element-60" />
          </div>

          <Button fullWidth className="py-4 md:py-5 text-[15px] md:text-xl mb-6 md:mb-8" onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-61">
            QUIERO MI MEGAPACK AHORA
          </Button>

          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-6 text-[11px] md:text-sm text-slate-400 font-medium" data-id="element-62">
            <span className="flex items-center gap-1" data-id="element-63">
              <Lock className="w-3.5 h-3.5 md:w-4 md:h-4 text-sky-400" data-id="element-64" /> Pago
              seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-65">
              <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 text-sky-400" data-id="element-66" /> Acceso
              inmediato
            </span>
            <span className="flex items-center gap-1" data-id="element-67">
              <Shield className="w-3.5 h-3.5 md:w-4 md:h-4 text-sky-400" data-id="element-68" />{' '}
              Garantía 7 días
            </span>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}